<div class="events-listing-container listing-full-size">
  <cdk-virtual-scroll-viewport *ngIf="['events_view','bookings_view','friends_view','groups_view'].indexOf(state) !== -1"
                               itemSize="typicalItemHeight" minBufferPx="300" maxBufferPx="600"
                               class="cdk-scroll">
    <div class="event-view-content event-view-content-first-row">
      <div class="flex-column-center">
        <div class="event-user-icon event-user-icon-first-row bigger-badge"
             matBadge="{{profile.rank}}" matBadgeColor="accent">
          <img src="{{profile['picture_src_preview']}}"
               alt="{{profile['shipping_name']}}" title="{{profile['shipping_name']}}"
               style="{{ profile['sex']==='F' ? 'border-color: #FF1744' : 'border-color: #448AFF' }}"
          />
        </div>
        <div class="user-name">
          <span *ngIf="isTrainer">🎓 </span>{{profile['shipping_name']}}
        </div>
      </div>
      <div *ngIf="!(application.account && application.account.payload_parsed['hide_connect_for_user'])" class="event-description flex-row-center flex-justify-space-around">
        <button mat-raised-button *ngIf="!showMyProfile"
                class="cancel widerButton font16" color="accent"
                (click)="pickPlayerForGame()">
          <ng-container *ngIf="isTrainer">📆{{'connect_game_icon' | GetLabelPipe}} {{'call_to_game_trainer' | GetLabelPipe}}</ng-container>
          <ng-container *ngIf="!isTrainer">📆{{'connect_game_icon' | GetLabelPipe}} {{'call_to_game' | GetLabelPipe}}</ng-container>
        </button>
        <button mat-raised-button  *ngIf="showMyProfile"
                class="cancel widerButton font16" color="accent"
                (click)="startBooking()">
          📆 {{'book_court' | GetLabelPipe}}
        </button>
        <button mat-raised-button class="cancel thinButton font16" color="accent"
                [matMenuTriggerFor]="showMyProfile ? personalMenu : userMenu">
          {{'more1' | GetLabelPipe}} <mat-icon>more_vert</mat-icon>
        </button>
      </div>
      <div class="activity-header" *ngIf="state === 'events_view'">
        <ng-container *ngIf="showMyProfile; else user_activity">{{'my_activity' | GetLabelPipe}}</ng-container>
        <ng-template #user_activity>
          {{'user_activity' | GetLabelPipe}}
        </ng-template>
      </div>
      <div class="activity-header" *ngIf="state === 'bookings_view'">
        <ng-container *ngIf="showMyProfile; else user_booking">{{'my_bookings' | GetLabelPipe}}</ng-container>
        <ng-template #user_booking>
          User Bookings
        </ng-template>
        <button type="button" mat-icon-button (click)="resumeEventsView()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <div class="activity-header" *ngIf="state === 'friends_view'">
        <ng-container *ngIf="showMyProfile; else user_friends">{{'my_friends' | GetLabelPipe}}</ng-container>
        <ng-template #user_friends>
          User Friends
        </ng-template>
        <button type="button" mat-icon-button (click)="resumeEventsView()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <div class="activity-header" *ngIf="state === 'groups_view'">
        <ng-container *ngIf="showMyProfile; else user_groups">{{'my_groups' | GetLabelPipe}}</ng-container>
        <ng-template #user_groups>
          User Groups
        </ng-template>
        <button type="button" mat-icon-button (click)="resumeEventsView()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

    <div *ngIf="state === 'events_view' || state === 'bookings_view'">
      <app-event-listing-item *cdkVirtualFor="let listItem of listing.listItems;" [listItem]="listItem"
        [activeItemCounter]="listing.selectedListItems.length">
      </app-event-listing-item>
    </div>

    <div *ngIf="state === 'friends_view'">
      <app-listing-item *cdkVirtualFor="let listItem of listing.listItems;" [listItem]="listItem"
                        [activeItemCounter]="listing.selectedListItems.length"
                        (click)="friendInviteOrView(listItem.itemFullData)">
      </app-listing-item>
    </div>

<!--    <div *ngIf="loadingSubItems" class="internal-spinner">-->
<!--      <svg class="spinner" viewBox="25 25 50 50">-->
<!--        <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10" />-->
<!--      </svg>-->
<!--    </div>-->

    <div class="tiles-scroll-container center75" *ngIf="state === 'groups_view'">
      <app-tile-listing-item *ngFor="let listItem of listing.listItems; let j = index" [idx]="j" [listItem]="listItem"
                             [activeItemCounter]="listing.selectedListItems.length"
                             [viewState]="'community_class'"
                             (click)="clickOnClass($event,listItem)"
                             (clickCourseShares)="clickOnClassShare($event,listItem)"
                             (clickEditFolder)="editClass($event,listItem)"
                             (clickAssignGroupUsers)="assignGroupUsers($event,listItem)">
      </app-tile-listing-item>
      <div *ngIf="listing.listItems.length;" class="clear_both">&nbsp;</div>

<!--      <section *ngIf="!listing.listItems.length;" class="empty-folder" fxLayout="column" fxLayoutAlign="center center"-->
<!--               style="text-align: center;">-->
<!--        <span *ngIf="true; else emptyAfterFilter">-->
<!--          <mat-icon>folder_open</mat-icon>-->
<!--          <p>No items found.</p>-->
<!--        </span>-->
<!--        <ng-template #emptyAfterFilter>-->
<!--          <mat-icon>search</mat-icon>-->
<!--          <p>No filter results.</p>-->
<!--          <p class="secondary">Try another query</p>-->
<!--        </ng-template>-->
<!--      </section>-->
    </div>

    <section *ngIf="!listing.listItems.length;" class="empty-folder" fxLayout="column" fxLayoutAlign="center center"
             style="text-align: center;">
      <ng-container>
        <span *ngIf="state === 'friends_view'">
          <mat-icon>person</mat-icon>
          <p>{{'no_records_found' | GetLabelPipe}}</p>
          <p>
            <button type="submit" class="cancel widerButton font16" mat-raised-button
                    color="accent"
                    (click)="friendInviteOrView()">
              <mat-icon style="font-size: 24px; color: inherit;">person_search</mat-icon> {{'add_new_friend'|GetLabelPipe}}
            </button>
          </p>
        </span>
        <span *ngIf="state === 'groups_view'">
          <mat-icon>person</mat-icon>
          <p>{{'no_records_found' | GetLabelPipe}}</p>
          <p>
            <button type="submit" class="cancel widerButton font16" mat-raised-button
                    color="accent"
                    (click)="groupEdit()">
              <mat-icon style="font-size: 24px; color: inherit;">group_add</mat-icon> {{'add_new_group'|GetLabelPipe}}
            </button>
          </p>
        </span>
        <span *ngIf="['friends_view','groups_view'].indexOf(state) === -1">
          <mat-icon>event_busy</mat-icon>
          <p>{{'no_records_found' | GetLabelPipe}}</p>
        </span>
      </ng-container>
    </section>
  </cdk-virtual-scroll-viewport>

  <div *ngIf="state === 'loading'" class="internal-spinner">
    <svg class="spinner" viewBox="25 25 50 50">
      <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10" />
    </svg>
  </div>

</div>

<mat-menu #userMenu="matMenu" class="file-menu">
  <button mat-menu-item (click)="messageUser()">
    <mat-icon>insert_comment</mat-icon>
    {{'message' | GetLabelPipe}}
  </button>

  <ng-container *ngIf="relationStatus">
  <hr>
  <button mat-menu-item (click)="friendshipClick()">
    <mat-icon>manage_accounts</mat-icon>
    <ng-container *ngIf="!relationAction">
    {{'remove_from_friends_popup_title' | GetLabelPipe}}
    </ng-container>
    <ng-container *ngIf="relationAction === 'wait_approve'">
    {{'wait_friend_approval_popup_title' | GetLabelPipe}}
    </ng-container>
    <ng-container *ngIf="relationAction === 'my_approve'">
    {{'approve_as_friends_popup_title' | GetLabelPipe}}
    </ng-container>
  </button>
  </ng-container>

  <ng-container *ngIf="!relationStatus">
  <hr>
  <button mat-menu-item (click)="friendshipClick()">
    <mat-icon>person_add</mat-icon>
    {{'add_to_friends' | GetLabelPipe}}
  </button>
  </ng-container>
<!--  <hr>-->
<!--  <button mat-menu-item (click)="comingSoon()">-->
<!--    <mat-icon>group_add</mat-icon>-->
<!--    {{'add_to_group' | GetLabelPipe}}-->
<!--  </button>-->
<!--  <hr>-->
<!--  <button mat-menu-item (click)="comingSoon()">-->
<!--    <mat-icon>card_giftcard</mat-icon>-->
<!--    Send gift-->
<!--  </button>-->
</mat-menu>

<mat-menu #personalMenu="matMenu" class="file-menu">
  <button mat-menu-item (click)="myBookingsPicked()">
    <mat-icon>history</mat-icon>
    {{'my_bookings' | GetLabelPipe}}
  </button>
  <hr>
<!--  <button mat-menu-item (click)="myTrainersPicked()">-->
<!--    <mat-icon>sports_handball</mat-icon>-->
<!--    {{'my_trainers' | GetLabelPipe}}-->
<!--  </button>-->
<!--  <hr>-->
  <button mat-menu-item (click)="myFriendsPicked()">
    <mat-icon>person</mat-icon>
    {{'my_friends' | GetLabelPipe}}
  </button>
  <hr>
  <button mat-menu-item (click)="friendInviteOrView()">
    <mat-icon>person_search</mat-icon>
    {{'add_new_friend' | GetLabelPipe}}
  </button>
  <hr>
  <button mat-menu-item (click)="myGroupsPicked()">
    <mat-icon>groups</mat-icon>
    {{'my_groups' | GetLabelPipe}}
  </button>
  <hr>
  <button mat-menu-item (click)="groupEdit()">
    <mat-icon>group_add</mat-icon>
    {{'add_new_group' | GetLabelPipe}}
  </button>
</mat-menu>

